<template>
  <el-dialog :title="$t('message.inquiryRecords')" :visible.sync="dialogVisible" width="760px"
    :close-on-click-modal="false" append-to-body>
    <div v-loading="loading" class="inquiry-list">
      <el-empty v-if="!loading && !detail.taskId" :description="$t('message.noInquiryRecords')" />
      <template v-if="detail.taskId">
        <div class="inquiry-head">
          <div>
            <el-tag size="small">{{ detail.taskName }}</el-tag>
            <el-tag size="small" :type="getStatusType(inquiryStatus)">{{ inquiryStatus }}</el-tag>
          </div>
          <span class="task-id">{{ $t('message.taskId') }}：{{ detail.taskId }}</span>
        </div>
        <div class="question">
          <b>{{ $t('message.inquiryQuestion') }}：</b>{{ detail.questions.join('、') }}
        </div>

        <!-- 具体内容按接口 subTasks/topics 层级展示商家完整对话。 -->
        <div class="dialogues">
          <div class="answer-title">{{ $t('message.dialogueContent') }}</div>
          <template v-for="(subTask, subTaskIndex) in detail.subTasks">
            <div v-for="(topic, topicIndex) in subTask.topics" :key="`${subTaskIndex}-${topicIndex}`"
              class="dialogue-item">
              <div class="dialogue-head">
                <span>{{ topic.topicName }}</span>
                <el-tag size="mini" :type="getStatusType(topic.status)">{{ topic.status }}</el-tag>
              </div>
              <div v-if="topic.imOrderModel" class="product-info">
                <el-image v-if="topic.imOrderModel.mainSummImageUrl" :src="topic.imOrderModel.mainSummImageUrl"
                  fit="cover" />
                <span>{{ topic.imOrderModel.productName }}</span>
              </div>
              <pre v-if="topic.imOrderModel && topic.imOrderModel.dialogue" class="dialogue-content">{{ topic.imOrderModel.dialogue }}</pre>
              <div v-else class="empty-answer">{{ $t('message.noDialogueContent') }}</div>
            </div>
          </template>
        </div>

        <div class="answers">
          <div class="answer-title">{{ $t('message.refinedAnswers') }}</div>
          <div v-if="!answers.length" class="empty-answer">{{ $t('message.noRefinedAnswers') }}</div>
          <div v-for="(answer, index) in answers" :key="index" class="answer-row">
            <span>{{ answer.question }}</span>
            <span>{{ answer.answer }}</span>
          </div>
        </div>
      </template>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">{{ $t('message.ok') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'GoodsInquiryRecords',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      inquiryStatus: '',
      answers: [],
      detail: {
        taskId: '',
        taskName: '',
        questions: [],
        subTasks: []
      }
    }
  },
  methods: {
    // 弹窗接口返回单个询盘任务，具体对话位于 subTasks[].topics[].imOrderModel.dialogue。
    open(orderDetailId) {
      this.inquiryStatus = ''
      this.answers = []
      this.detail = { taskId: '', taskName: '', questions: [], subTasks: [] }
      this.dialogVisible = true
      this.loading = true
      this.$api.orderApi.purchaseGoodsInquiryPopup({ order_detail_id: orderDetailId }).then(res => {
        this.detail = res.data
        this.inquiryStatus = res.inquiryStatus
        this.answers = res.answers
      }).finally(() => {
        this.loading = false
      })
    },
    // 任务状态转为 Element 标签状态。
    getStatusType(status) {
      if (status === 'SUCCESS') return 'success'
      if (status === 'FAIL' || status === 'FAILED') return 'danger'
      if (status === 'PENDING') return 'warning'
      return 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
.inquiry-list {
  min-height: 180px;
  max-height: 65vh;
  overflow-y: auto;
}

.inquiry-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;

  .el-tag {
    margin-right: 8px;
  }
}

.task-id,
.empty-answer {
  color: #909399;
}

.question {
  line-height: 22px;
  word-break: break-all;
}

.dialogues,
.answers {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #ebeef5;
}

.answer-title {
  margin-bottom: 8px;
  font-weight: 600;
}

.dialogue-item {
  margin-bottom: 12px;
  padding: 12px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.dialogue-head,
.product-info {
  display: flex;
  align-items: center;
}

.dialogue-head {
  justify-content: space-between;
  margin-bottom: 10px;
  font-weight: 600;
}

.product-info {
  gap: 10px;
  margin-bottom: 10px;

  .el-image {
    width: 48px;
    height: 48px;
    flex: none;
  }
}

.dialogue-content {
  margin: 0;
  padding: 12px;
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 22px;
  font-family: inherit;
  color: #606266;
  background: #f7f8fa;
}

.answer-row {
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 12px;
  padding: 7px 10px;
  background: #f7f8fa;
  border-bottom: 1px solid #ebeef5;

  span {
    word-break: break-all;
  }
}
</style>
